import { InjectionToken } from '@angular/core';

export let ADDRESS_SERVICE_URL = new InjectionToken<string>(
    'ADDRESS_SERVICE_URL',
);
